import React, { useState } from 'react';

const VideoCard = ({ title, name, role, youtubeUrl }) => {
  const [embedError, setEmbedError] = useState(false);
  const [useYouTubeNoCookie, setUseYouTubeNoCookie] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  const getEmbedUrl = (url, useNoCookie = false) => {
    let videoId = '';

    if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1].split('?')[0];
    } else if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('v=')[1].split('&')[0];
    } else if (url.includes('youtube.com/embed/')) {
      videoId = url.split('embed/')[1].split('?')[0];
    }

    if (videoId) {
      const domain = useNoCookie ? 'youtube-nocookie.com' : 'youtube.com';
      const origin = window.location.origin;
      return `https://www.${domain}/embed/${videoId}?origin=${encodeURIComponent(origin)}&rel=0&modestbranding=1`;
    }

    return url;
  };

  const getWatchUrl = (url) => {
    let videoId = '';

    if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1].split('?')[0];
    } else if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('v=')[1].split('&')[0];
    } else if (url.includes('youtube.com/embed/')) {
      videoId = url.split('embed/')[1].split('?')[0];
    }

    return videoId ? `https://www.youtube.com/watch?v=${videoId}` : url;
  };

  const embedUrl = getEmbedUrl(youtubeUrl, useYouTubeNoCookie);

  const handleIframeError = () => {
    if (!useYouTubeNoCookie && retryCount < 1) {
      setUseYouTubeNoCookie(true);
      setRetryCount(retryCount + 1);
    } else {
      setEmbedError(true);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-lg transition-shadow duration-300 flex flex-col h-full">
      <div className="relative w-full bg-gray-100" style={{ paddingBottom: '56.25%' }}>
        {embedError ? (
          <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center">
            <svg className="w-14 h-14 text-red-500 mb-3" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
            </svg>
            <p className="text-sm text-gray-600 mb-3">Video failed to load</p>
            <a
              href={getWatchUrl(youtubeUrl)}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-ifys-blue text-white rounded-lg hover:bg-ifys-dark-blue transition-colors text-sm"
            >
              Watch on YouTube
            </a>
          </div>
        ) : (
          <iframe
            key={`${name}-${useYouTubeNoCookie}`}
            src={embedUrl}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            className="absolute inset-0 w-full h-full"
            loading="lazy"
            onLoad={() => setEmbedError(false)}
            onError={handleIframeError}
          />
        )}
      </div>
      <div className="p-4 sm:p-5 flex-1 flex flex-col justify-center">
        <p className="font-semibold text-ifys-blue text-sm sm:text-base truncate">{name}</p>
        <p className="text-gray-600 text-xs sm:text-sm truncate mt-0.5">{role}</p>
      </div>
    </div>
  );
};

export default VideoCard;
